
import i18n from '@/lang/index.js';
"use strict";

import GoEasy from 'goeasy';
import { getConnection } from '@/api/courseApi/knowledge.js'
import { isI18n } from '@/config'

const websocket = {
	$goEasy: null,
	isConnected: false,
	messageListener: {},
	init() {
		let options = {
			host: "hangzhou.goeasy.io",
			appkey: "PC-4ef229419a1f4064ae9bc56d45c6fc73",
			modules: ['pubsub'] //根据需要，传入‘pubsub’或'im’，或数组方式同时传入
		}
		if (isI18n) {
			options.host = "singapore.goeasy.io"
			options.appkey = "PC-30188eaa4d6a479f961de4ab4cdd2c62"
		}
		this.$goEasy = GoEasy.getInstance(options);
	},
	connect(channel) {
		getConnection(channel).then(data => {
			if (data) {
				this.$goEasy.connect({
					otp: data,
					onSuccess: () => { //连接成功
						this.isConnected = true
						this.subscribe(channel)
						console.log("GoEasy connect successfully.") //连接成功
					},
					onFailed: function (error) { //连接失败
						this.isConnected = false
						console.log("Failed to connect GoEasy, code:" + error.code + ",error:" + error.content);
					},
					onProgress: function (attempts) { //连接或自动重连中
						console.log("GoEasy is connecting", attempts);
					}
				});
			}
		}).catch(e => {
			console.log(e)
		})
	},
	subscribe(channel) {
		this.$goEasy.pubsub.subscribe({
			channel: channel,
			onMessage: message => {
				message.content = JSON.parse(message.content)
				console.log("Channel:" + message.channel + " content:" + message.content);
				try {
					if (this.messageListener[message.content.code]) {
						this.messageListener[message.content.code](message.content)
					}
				} catch (error) {
					console.log(error)
				}
			}
		});
	},
	unsubscribe(channel) {
		goeasy.pubsub.unsubscribe({
			channel: channel,
			onSuccess: function () {
				alert(i18n.t('utils_websocket_925'));
			},
			onFailed: function (error) {
				alert(i18n.t('utils_websocket_926') + error.code + i18n.t('utils_websocket_927') + error.content)
			}
		});
	},
	sendMessage(channel, message, success, fail) {
		this.$goEasy.pubsub.publish({
			channel: channel,//替换为您自己的channel
			message: message,//替换为您想要发送的消息内容
			onSuccess: function () {
				success && success()
				console.log(i18n.t('utils_websocket_928'));
			},
			onFailed: function (error) {
				fail && fail(error)
				console.log(i18n.t('utils_websocket_929') + error.code + i18n.t('utils_websocket_930') + error.content);
			}
		});
	},
	disconnect() {
		// 断开连接
		this.$goEasy && this.$goEasy.disconnect({
			onSuccess: function () {
				this.isConnected = false
				console.log("GoEasy disconnect successfully.")
			},
			onFailed: function (error) {
				console.log("Failed to disconnect GoEasy, code:" + error.code + ",error:" + error.content);
			}
		});
	},
	// 监听code类型
	registMessageListener(code, callback) {
		this.messageListener[code] = callback
	},
	// 取消监听code类型
	unRegistMessageListener(code) {
		delete this.messageListener[code]
	},
}

websocket.init()

export default websocket